import axios from 'axios';

export const getTalentsList = async (page, per_page, max_pages, filters = {}, user = null) => {
    try {
        // Add employer_status to filters if user is logged in and is an employer
        if (user && user.account_type === 'employer') {
            filters.employer_status = user.employer_status;
        }
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}talents/getTalentsList`, {
            params: {
                page: page,
                per_page: per_page,
                max_pages: max_pages,
                filters: filters
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getFavoriteTalents = async (userId, page = 1, per_page = 10, filters = {}, user = null) => {
    try {
        // Add employer_status to filters if user is logged in and is an employer
        if (user && user.account_type === 'employer') {
            filters.employer_status = user.employer_status;
        }
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}talents/favorites/list`, {
            params: {
                userId,
                page,
                per_page,
                filters,
            },
        });
        return response.data;

    } catch (error) {
        console.log(error, 'error')
        throw error.response?.data || error.message;
    }
};
export const getJobSeekerList = async (userId,) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}talents/favorites/lists?userId=${userId}`
        );
        return response;

    } catch (error) {
        console.log(error, 'error')
        throw error.response?.data || error.message;
    }
};
